import { recalculateTargetGrossMargin } from '../strategies/target-gross-margin';
import { RecalculatePriceStrategy } from '../types';

/**
 * Unreachable in practice: no field on an alpha line is editable in Quote
 * Builder, so no change ever dispatches these. They stay because the strategy
 * contract requires both handlers — only `onQuantityChange` is nullable — and
 * widening that for one strategy would weaken it for the other sixteen.
 */
export const recalculateAlpha = {
  onQuantityChange: null,
  onUnitPriceChange: recalculateTargetGrossMargin.onUnitPriceChange,
  onGrossMarginChange: recalculateTargetGrossMargin.onGrossMarginChange,
  onContributionMarginChange: null,
  onBaseGrossMarginChange: null,
  onUnitCostChange: null,
  onQuotePriceCreation: null,
} satisfies RecalculatePriceStrategy;
